module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageSuperbowl.elements) ? _c('div', {
    staticClass: "superbowl dexcom"
  }, [_c('hero', {
    attrs: {
      "props": _vm.pageSuperbowl.elements,
      "heroHome": false
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "inside text-center"
  }, [_c('h1', {
    staticClass: "main-title"
  }, [_vm._v(_vm._s(_vm.pageSuperbowl.elements.title_content.value))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.pageSuperbowl.elements.main_content.value)
    }
  })])]), _vm._v(" "), (_vm.pageSuperbowl.elements != undefined) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section video"
  }, [(_vm.pageSuperbowl.elements.video_url.value != undefined) ? _c('div', {
    staticClass: "video-content"
  }, [(_vm.pageSuperbowl.elements.poster_url.value != '') ? _c('video', {
    attrs: {
      "controls": "",
      "poster": _vm.pageSuperbowl.elements.poster_url.value[0].url
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.pageSuperbowl.elements.video_url.value
    }
  })]) : _c('video', {
    attrs: {
      "controls": "",
      "preload": "metadata"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.pageSuperbowl.elements.video_url.value
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('contact', {
    attrs: {
      "contactFormInfo": _vm.contactFormInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('Footer')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e5e226","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Dexcom.vue
// module id = 1522
// module chunks = 0